import { useEffect } from 'react';
import { photoSrc } from '../api';

/**
 * Tiles an image behind the entire page (under the top bar and tab bar too)
 * while the calling screen is mounted. Cards go translucent so the pattern
 * shows through between them.
 */
export function useTiledBackground(url: string | null | undefined) {
  useEffect(() => {
    const src = photoSrc(url ?? null);
    if (!src) return;
    const body = document.body;
    body.classList.add('tiled');
    body.style.backgroundImage = `url("${src}")`;
    return () => {
      body.classList.remove('tiled');
      body.style.backgroundImage = '';
    };
  }, [url]);
}
